import React, { useContext, useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { DRAWER_WIDTH } from '../theme/CustomThemeProvider';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import SwapVertOutlinedIcon from '@material-ui/icons/SwapVertOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import MenuBookOutlinedIcon from '@material-ui/icons/MenuBookOutlined';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import NotificationsActiveOutlinedIcon from '@material-ui/icons/NotificationsActiveOutlined';
import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
//import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import EngineeringIcon from '@mui/icons-material/Engineering';
import { ROUTES } from '../constants/RoutingConstants';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Tooltip, Typography } from '@material-ui/core';
import { ExitToApp, ListAlt } from '@material-ui/icons';
import { redirectLogout } from '../utils/RoutingUtils';
import { LoginContext } from '../contexts/LoginContext';
import MyAccountAvatar from './MyAccountAvatar';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import BalanceIcon from '@mui/icons-material/Balance';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import InventoryIcon from '@mui/icons-material/Inventory';

import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import PendingActionsIcon from '@mui/icons-material/PendingActionsOutlined';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ContactMailIcon from '@mui/icons-material/ContactMail';


const useStyles = makeStyles(theme => ({
  drawer: {
    width: DRAWER_WIDTH,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxShadow: '10px 40px 49px -28px rgba(0,0,0,1)',
  },
  drawerOpen: {
    width: DRAWER_WIDTH,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(8) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  userAvatarActions: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logout: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '1em',
  },
}));

const menuOptions = {
  CHECKING_ACCOUNT: { label: 'Estado de cuenta', icon: <MonetizationOnOutlinedIcon />, route: ROUTES.CHECKING_ACCOUNT },
  PAYMENT_ORDERS_WITHHOLDINGS: {
    label: 'Ordenes de pago y retenciones',
    icon: <DescriptionOutlinedIcon />,
    route: ROUTES.PAYMENT_ORDERS_WITHHOLDINGS,
  },
  EXCHANGE_DIFFERENCE: { label: 'Diferencia de cambio', icon: <SwapVertOutlinedIcon />, route: ROUTES.EXCHANGE_DIFFERENCE },
  PURCHARSE_ORDERS: { label: 'Pedidos de compra', icon: <AssignmentOutlinedIcon />, route: ROUTES.PURCHARSE_ORDERS },
  SERVICE_PAGE: { label: 'Hojas de servicio', icon: <MenuBookOutlinedIcon />, route: ROUTES.SERVICE_PAGE },
  LOGISTICS: { label: 'Logística', icon: <LocalShippingOutlinedIcon />, route: ROUTES.LOGISTICS },
  NOTIFICATIONS: { label: 'Notificaciones', icon: <NotificationsActiveOutlinedIcon />, route: ROUTES.NOTIFICATIONS },
  MERCHANDISE_REMITTANCE: {
    label: 'Remitos de entrega de mercadería',
    icon: <AssignmentTurnedInOutlinedIcon />,
    route: ROUTES.MERCHANDISE_REMITTANCE,
  },
  CLAIM_MGMT: { label: 'Gestión de Reclamos', icon: <ReportProblemOutlinedIcon />, route: ROUTES.CLAIM_MGMT },
  CLAIM_STATS: { label: 'Estadísticas de Reclamos', icon: <AssessmentOutlinedIcon />, route: ROUTES.CLAIM_STATS },
  USER_ADMINISTRATION: { label: 'Administración de usuarios', icon: <AssignmentIndIcon />, route: ROUTES.USER_ADMINISTRATION },
  EMPLOYEE_ADMINISTRATION: { label: 'Administración de empleados', icon: <EngineeringIcon />, route: ROUTES.EMPLOYEE_ADMINISTRATION },
  COMUNICATION_SITES: { label: 'Línea Ética', icon: <BalanceIcon />, route: ROUTES.COMUNICATION_SITES },
  HELP_INFORMATION: { label: 'Ayuda', icon: <ContactSupportIcon />, route: ROUTES.HELP_INFORMATION },

  SCRAPS: { label: 'Chatarra', icon: <InventoryIcon />, route: ROUTES.SCRAPS },
  
  QUALITY_CERTIFICATE_REQUESTS: { label: 'Carga de certificado de calidad', icon: <PendingActionsIcon/>, route: ROUTES.QUALITY_CERTIFICATE_REQUESTS },

  MATERIALS_REQUIRES: { label: 'Requerimiento de Certificados', icon: <AppRegistrationIcon/>, route: ROUTES.MATERIALS_REQUIRES },
  EXCLUDED_SUPPLIERS_CERTIFICATE: {label: 'Proveedores excluidos', icon: <ContactPageIcon/>, route: ROUTES.EXCLUDED_SUPPLIERS_CERTIFICATE},
  EXCLUDED_PURCHASE_ORDERS: {label: 'Ordenes de compras excluidas', icon: <AssignmentLateOutlinedIcon/>, route: ROUTES.EXCLUDED_PURCHASE_ORDERS},

  EMPLOYEE: { label: 'Empleados', route: ROUTES.EMPLOYEES },
  ACTIVITY_LOGS: { label: 'Actividades de logueo', icon: <ListAlt />, route: ROUTES.ACTIVITY_LOGS},
  EMAIL_NOTIFICATION: { label: 'Gestión email de notificación', icon: <ContactMailIcon/>, route: ROUTES.EMAIL_NOTIFICATION}
};

const userTypes = [
  {
    name: 'PROVEEDOR NO TRANSPORTISTA',
    menuOptionsAllowed: [
      menuOptions.CHECKING_ACCOUNT,
      menuOptions.PAYMENT_ORDERS_WITHHOLDINGS,
      menuOptions.EXCHANGE_DIFFERENCE,
      menuOptions.PURCHARSE_ORDERS,
      menuOptions.SERVICE_PAGE,
      menuOptions.QUALITY_CERTIFICATE_REQUESTS,
      menuOptions.EMPLOYEE_ADMINISTRATION,
      menuOptions.NOTIFICATIONS,
      menuOptions.MERCHANDISE_REMITTANCE,
      menuOptions.CLAIM_MGMT,
      menuOptions.COMUNICATION_SITES,
      menuOptions.HELP_INFORMATION,
    ],
  },
  {
    name: 'PROVEEDOR TRANSPORTISTA',
    menuOptionsAllowed: [
      menuOptions.CHECKING_ACCOUNT,
      menuOptions.PAYMENT_ORDERS_WITHHOLDINGS,
      menuOptions.EXCHANGE_DIFFERENCE,
      menuOptions.PURCHARSE_ORDERS,
      menuOptions.LOGISTICS, 
      menuOptions.QUALITY_CERTIFICATE_REQUESTS,
      menuOptions.EMPLOYEE_ADMINISTRATION,
      menuOptions.NOTIFICATIONS,
      menuOptions.MERCHANDISE_REMITTANCE,
      menuOptions.CLAIM_MGMT,
      menuOptions.COMUNICATION_SITES,
      menuOptions.HELP_INFORMATION,
    ],
  },
  {
    name: 'CUENTAS A PAGAR',
    menuOptionsAllowed: [
      menuOptions.CHECKING_ACCOUNT,
      menuOptions.PAYMENT_ORDERS_WITHHOLDINGS,
      menuOptions.EXCHANGE_DIFFERENCE,
      menuOptions.PURCHARSE_ORDERS,
      menuOptions.SERVICE_PAGE,      
      menuOptions.NOTIFICATIONS,
      menuOptions.MERCHANDISE_REMITTANCE,
      menuOptions.SCRAPS,
      menuOptions.CLAIM_MGMT,
      menuOptions.CLAIM_STATS,
      menuOptions.COMUNICATION_SITES,
      menuOptions.HELP_INFORMATION,
    ],
  },
  {
    name: 'COMPRAS',
    menuOptionsAllowed: [
      menuOptions.CHECKING_ACCOUNT,
      menuOptions.PAYMENT_ORDERS_WITHHOLDINGS,
      menuOptions.PURCHARSE_ORDERS,
      menuOptions.SERVICE_PAGE,
      menuOptions.NOTIFICATIONS,
      menuOptions.MERCHANDISE_REMITTANCE,
      menuOptions.CLAIM_MGMT,
      menuOptions.CLAIM_STATS,
      menuOptions.COMUNICATION_SITES,
      menuOptions.HELP_INFORMATION,
    ],
  },
  {
    name: 'LOGÍSTICA',
    menuOptionsAllowed: [
      menuOptions.CHECKING_ACCOUNT,
      menuOptions.PAYMENT_ORDERS_WITHHOLDINGS,
      menuOptions.SERVICE_PAGE,
      menuOptions.LOGISTICS,
      menuOptions.NOTIFICATIONS,
      menuOptions.MERCHANDISE_REMITTANCE,
      menuOptions.CLAIM_MGMT,
      menuOptions.CLAIM_STATS,
      menuOptions.COMUNICATION_SITES,
      menuOptions.HELP_INFORMATION,
    ],
  },
  {
    name: 'ADMINISTRADOR',
    menuOptionsAllowed: [
      menuOptions.CHECKING_ACCOUNT,
      menuOptions.PAYMENT_ORDERS_WITHHOLDINGS,
      menuOptions.EXCHANGE_DIFFERENCE,
      menuOptions.PURCHARSE_ORDERS,
      menuOptions.SERVICE_PAGE,
      menuOptions.LOGISTICS,
      menuOptions.SCRAPS,
      menuOptions.QUALITY_CERTIFICATE_REQUESTS,
      menuOptions.NOTIFICATIONS,
      menuOptions.MATERIALS_REQUIRES,
      menuOptions.EXCLUDED_SUPPLIERS_CERTIFICATE,
      menuOptions.EXCLUDED_PURCHASE_ORDERS,
      menuOptions.EMAIL_NOTIFICATION,
      menuOptions.MERCHANDISE_REMITTANCE,
      menuOptions.CLAIM_MGMT,
      menuOptions.CLAIM_STATS,
      menuOptions.USER_ADMINISTRATION,
      menuOptions.EMPLOYEE_ADMINISTRATION,
      menuOptions.ACTIVITY_LOGS,
      menuOptions.COMUNICATION_SITES,      
      menuOptions.HELP_INFORMATION
    ],
  },
  {
    name: 'AUDITORÍA',
    menuOptionsAllowed: [
      menuOptions.CHECKING_ACCOUNT,
      menuOptions.PAYMENT_ORDERS_WITHHOLDINGS,
      menuOptions.EXCHANGE_DIFFERENCE,
      menuOptions.PURCHARSE_ORDERS,
      menuOptions.SERVICE_PAGE,
      menuOptions.NOTIFICATIONS,
      menuOptions.MERCHANDISE_REMITTANCE,
      menuOptions.SCRAPS,
      menuOptions.CLAIM_MGMT,
      menuOptions.CLAIM_STATS,
      menuOptions.COMUNICATION_SITES,
      menuOptions.HELP_INFORMATION,
    ],
  },
  {
    name: 'CONTABILIDAD',
    menuOptionsAllowed: [
      menuOptions.CHECKING_ACCOUNT,
      menuOptions.PAYMENT_ORDERS_WITHHOLDINGS,
      menuOptions.PURCHARSE_ORDERS,
      menuOptions.MERCHANDISE_REMITTANCE,
      menuOptions.SCRAPS,
      menuOptions.CLAIM_STATS,
      menuOptions.COMUNICATION_SITES,
      menuOptions.HELP_INFORMATION,
    ],
  },
  {
    name: 'GENERAL',
    menuOptionsAllowed: [menuOptions.CLAIM_MGMT, menuOptions.CLAIM_STATS],
  },

  {
    name: 'CONTROL DE COMPRADORES',
    menuOptionsAllowed: [
      menuOptions.CHECKING_ACCOUNT,
      menuOptions.SCRAPS,
      menuOptions.NOTIFICATIONS,
      menuOptions.CLAIM_MGMT,
      menuOptions.COMUNICATION_SITES,      
      menuOptions.HELP_INFORMATION      
    ],
  },
  {
    name: 'CHATARRERO NO TRANSPORTISTA',
    menuOptionsAllowed: [
      menuOptions.CHECKING_ACCOUNT,
      menuOptions.PAYMENT_ORDERS_WITHHOLDINGS,
      menuOptions.EXCHANGE_DIFFERENCE,
      menuOptions.PURCHARSE_ORDERS,
      menuOptions.SCRAPS,
      menuOptions.SERVICE_PAGE,  
      menuOptions.QUALITY_CERTIFICATE_REQUESTS,
      menuOptions.EMPLOYEE_ADMINISTRATION,
      menuOptions.NOTIFICATIONS,
      menuOptions.MERCHANDISE_REMITTANCE,
      menuOptions.CLAIM_MGMT,
      menuOptions.COMUNICATION_SITES,     
      menuOptions.HELP_INFORMATION    
    ],
  },
  {
    name: 'CHATARRERO TRANSPORTISTA',
    menuOptionsAllowed: [
      menuOptions.CHECKING_ACCOUNT,
      menuOptions.PAYMENT_ORDERS_WITHHOLDINGS,
      menuOptions.EXCHANGE_DIFFERENCE,
      menuOptions.PURCHARSE_ORDERS,
      menuOptions.SCRAPS,
      menuOptions.LOGISTICS,
      menuOptions.QUALITY_CERTIFICATE_REQUESTS,
      menuOptions.EMPLOYEE_ADMINISTRATION,
      menuOptions.NOTIFICATIONS,
      menuOptions.MERCHANDISE_REMITTANCE,
      menuOptions.CLAIM_MGMT,
      menuOptions.COMUNICATION_SITES,     
      menuOptions.HELP_INFORMATION     
    ],
  },
  {
    name: 'GESTIÓN DE COMPRAS',
    menuOptionsAllowed: [
      menuOptions.CHECKING_ACCOUNT,
      menuOptions.NOTIFICATIONS,
      menuOptions.MATERIALS_REQUIRES,
      menuOptions.QUALITY_CERTIFICATE_REQUESTS,
      menuOptions.EXCLUDED_SUPPLIERS_CERTIFICATE,
      menuOptions.EXCLUDED_PURCHASE_ORDERS,
      menuOptions.CLAIM_MGMT,
      menuOptions.COMUNICATION_SITES,
      menuOptions.HELP_INFORMATION
    ],
  },
  {
    name: 'CONTROL DE CALIDAD',
    menuOptionsAllowed: [     
      menuOptions.MATERIALS_REQUIRES,
      menuOptions.QUALITY_CERTIFICATE_REQUESTS,
      menuOptions.EXCLUDED_SUPPLIERS_CERTIFICATE,
      menuOptions.EXCLUDED_PURCHASE_ORDERS,
      menuOptions.EMAIL_NOTIFICATION
           
    ],
  },
];

const MenuButtonsList = ({ userRole, setScreenTitle, openDrawer }) => {
  const history = useHistory();
  const location = useLocation();
  const menuOptions = userTypes.find(u => u.name === userRole).menuOptionsAllowed;

  useEffect(() => {
    const option = menuOptions.find(m => m.route === history.location.pathname);
    setScreenTitle(option?.label);
  }, []);

  const handleClick = option => {
    setScreenTitle(option.label);
    history.push(option.route);
  };

  return (
    <List>
      {menuOptions.map(option => (
        <ListItem button key={option.label} selected={location.pathname === option.route} onClick={() => handleClick(option)}>
          <Tooltip title={!openDrawer ? option.label : ''} enterDelay={1000}>
            <ListItemIcon>{option.icon}</ListItemIcon>
          </Tooltip>
          <ListItemText primary={option.label} />
        </ListItem>
      ))}
    </List>
  );
};

const Logout = () => {
  const classes = useStyles();

  return (
    <Button variant="text" color="secondary" onClick={redirectLogout}>
      <div className={classes.logout}>
        <ExitToApp /> <Typography>Salir</Typography>
      </div>
    </Button>
  );
};

const MenuDrawer = ({ openDrawer, setOpenDrawer, setScreenTitle }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { userInfo, isSupplier } = useContext(LoginContext);

  return (
    <Drawer
      variant="permanent"
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: openDrawer,
        [classes.drawerClose]: !openDrawer,
      })}
      classes={{
        paper: clsx({
          [classes.drawerOpen]: openDrawer,
          [classes.drawerClose]: !openDrawer,
        }),
      }}>
      <div className={classes.toolbar}>
        <div className={classes.userAvatarActions}>
          <MyAccountAvatar userInfo={userInfo} readOnly={!isSupplier} setOpenDrawer={setOpenDrawer} setScreenTitle={setScreenTitle} />
          <Logout />
        </div>
        <IconButton onClick={() => setOpenDrawer(false)}>
          {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </div>
      <Divider />
      <MenuButtonsList userRole={userInfo.role} setScreenTitle={setScreenTitle} openDrawer={openDrawer} />
    </Drawer>
  );
};

export default MenuDrawer;
